/*
 * B 版集合页内容流：把「产品卡之后的区块」（SEO／博客／FAQ…）上提，紧贴产品栅格。
 * 需求：需求/20260922-列表页产品卡AB实验/ → 子需求 06
 *
 * 背景（1440 实测）：.shop__content 是 flex 行，含
 *   筛选列 .shop__filters-column（316×1606）与产品列 .shop__products（1004×661）；
 *   行高取较高者 → products section 高 1702px，而产品栅格只到 y=1117
 *   → 其后的 SEO section 被推到 y=2110（空档约 1041px，用户反馈"筛选器撑下来了"）。
 *
 * 为什么必须用脚本：products section（.shopify-section）与 .shop__container 都是 overflow:hidden，
 * 所以纯 CSS 无解 —— ① 让筛选列「出流」（height:0 / position:absolute）会让超出部分被裁掉；
 * ② 跨 section 边界无法把后续 section 放进产品列。故只能量出空档后用负 margin-top 上提。
 *
 * 设计依据：Figma node 2941:2103 右栏（2941:2305）—— 产品栅格底 y=1763 → 后续内容 frame
 * （2961:9955）顶 y=1811，即 **48px** 间距；筛选列（316×2210）比栅格高，继续与后续内容左右并行。
 *
 * 作用范围：只在 .vl-collection-section 存在时生效
 *   （`sections/products.liquid` 在 bikes-1* 模板上直接输出的钩子类，2026-10-28 起为默认形态）。
 */
(function () {
  'use strict';

  var GAP = 48;                       /* px：Figma「产品栅格底 → 后续内容可见起点」的间距（1763 → 1811） */
  var HOOK = 'vl-collection-section'; /* 新版集合区块标记类 */
  var target = null;                  /* 当前被上提的 section */
  var observer = null;
  var timer = null;

  function resolve() {
    var wrapper = document.querySelector('.' + HOOK);
    if (!wrapper) return null;
    var section = wrapper.closest('.shopify-section') || wrapper;
    var products = wrapper.querySelector('.shop__products');
    if (!section || !products || !section.parentElement) return null;
    var next = section.nextElementSibling;
    while (next && !(next.nodeType === 1 && next.classList.contains('shopify-section'))) {
      next = next.nextElementSibling;
    }
    if (!next) return null;
    /* 不能把页脚拉上来 */
    if (/footer/.test(String(next.className || '')) || next.querySelector('.footer')) return null;
    return { products: products, next: next };
  }

  function firstVisibleChild(node) {
    for (var i = 0; i < node.children.length; i += 1) {
      if (node.children[i].getBoundingClientRect().height > 0) return node.children[i];
    }
    return null;
  }

  /*
   * 该 section「盒子顶 → 可见内容顶」的留白：沿「与父级同顶」的包装链累加 `padding-top`。
   * 用计算样式而不是几何差：AJAX 替换 / 图片加载 / 字体切换会让几何差在测量瞬间偏小
   * （实测 43.2 而非 48 → 最终间距 52.8），而 padding 不随这些过程变化。
   * 本模板：`.shopify-section.custom-section`(0) → `.custom-liquid.section`(0) → `.container`(48) = 48。
   */
  function leadingSpace(section) {
    var total = 0;
    var node = section;
    for (var guard = 0; guard < 8; guard += 1) {
      var pad = parseFloat(window.getComputedStyle(node).paddingTop) || 0;
      total += pad;
      if (pad > 0) break;                       /* 找到真正提供留白的盒子即停 */
      var kid = firstVisibleChild(node);
      if (!kid) break;
      node = kid;
    }
    return total;
  }

  function clear() {
    if (target) {
      target.style.marginTop = '';
      target = null;
    }
    if (observer) {
      observer.disconnect();
      observer = null;
    }
  }

  function apply() {
    var refs = resolve();
    if (!refs) {
      clear();
      return;
    }
    var next = refs.next;
    if (target && target !== next) target.style.marginTop = '';
    target = next;
    next.style.marginTop = '';                                  /* 先还原，量自然位置 */
    /* 目标＝内容可见起点落在「产品列底 + 48」：把 section 盒顶顶到 (产品列底 + 48 − 自身留白) */
    var want = refs.products.getBoundingClientRect().bottom + Math.max(0, GAP - leadingSpace(next));
    var pull = Math.round(next.getBoundingClientRect().top - want);
    if (pull > 1) next.style.marginTop = -pull + 'px';

    /*
     * 复核并按误差直接修正：图片/字体/内部布局常在「量完」之后才稳定，
     * 只靠 ResizeObserver 不保证能再触发（实测筛选后 gap 58.8 而非 48，手动 resize 才回到 47.8）。
     * 这里在同一坐标系（section 盒顶 vs want）复核 3 次、按误差改 marginTop；
     * 后续的图片 load / ResizeObserver 仍会兜底。
     */
    if (pull > 1) {
      for (var guard = 0; guard < 3; guard += 1) {
        var delta = next.getBoundingClientRect().top - want;
        if (Math.abs(delta) <= 1) break;
        var current = parseFloat(next.style.marginTop) || 0;
        next.style.marginTop = (current - delta) + 'px';
      }
    }

    /* 图片（含懒加载）加载完成还会改变产品列高度：对未完成的图片挂一次性回调，加载完重新量一次 */
    var pendingImgs = refs.products.querySelectorAll('img:not([data-vl-flow-watch])');
    Array.prototype.forEach.call(pendingImgs, function (img) {
      img.setAttribute('data-vl-flow-watch', 'true');
      if (img.complete && img.naturalWidth) return;
      img.addEventListener('load', function () { schedule(0); }, { once: true });
      img.addEventListener('error', function () { schedule(0); }, { once: true });
    });

    if (window.ResizeObserver && !observer) {
      observer = new ResizeObserver(function () { schedule(0); });
      observer.observe(refs.products);
    }
  }

  function schedule(delay) {
    if (timer) window.clearTimeout(timer);
    timer = window.setTimeout(function () {
      timer = null;
      run();
    }, typeof delay === 'number' ? delay : 120);
  }

  /*
   * AJAX 替换（筛选/排序）时产品列高度会先虚高再回落（实测 apply 时量到 1086，稳定后 1079.2），
   * 而 ResizeObserver 不保证在回落时再触发一次 ⇒ 替换后补几次延时复量，保证最终落点。
   */
  function scheduleFollowUps() {
    [350, 900, 1800].forEach(function (delay) {
      window.setTimeout(function () {
        if (document.querySelector('.' + HOOK)) run();
      }, delay);
    });
  }

  function run() {
    if (!document.querySelector('.' + HOOK)) {                  /* 非新版集合页：清掉可能残留的上提 */
      clear();
      return;
    }
    apply();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run, { once: true });
  } else {
    run();
  }
  window.addEventListener('resize', function () { schedule(150); });
  window.addEventListener('load', function () { schedule(0); });
  document.addEventListener('shopify:section:load', function () { schedule(0); });
  /* 筛选/排序是 AJAX 替换产品列（见 assets/vl-product-card.js 的观察逻辑）：卡片数量与行高变了要重新量 */
  document.addEventListener('vl-collection:cards-updated', function () {
    schedule(0);
    scheduleFollowUps();
  });
})();
